import React, { FunctionComponent } from 'react';
import { IconProps } from '.';

const ArrowUp: FunctionComponent<IconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24' fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M12 19L12 5' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M9 8L12 5L15 8' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round' />
  </svg>

)

export default ArrowUp;
